import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  opacity: "0.4",
  d: "M10.9939 14.6666H5.00721C2.66721 14.6666 2.16055 13.3266 2.35388 11.6866L2.95388 6.68658C3.10721 5.39325 3.33388 4.33325 5.60054 4.33325H10.4006C12.6672 4.33325 12.8939 5.39325 13.0472 6.68658L13.5472 10.8533L13.6472 11.6866C13.6539 11.7399 13.6605 11.7932 13.6672 11.8466C13.8072 13.4132 13.2606 14.6666 10.9939 14.6666Z",
  fill: "#697B8E"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M10.6654 5.83325C10.392 5.83325 10.1654 5.60659 10.1654 5.33325V2.99992C10.1654 2.27992 9.7187 1.83325 8.9987 1.83325H6.9987C6.2787 1.83325 5.83203 2.27992 5.83203 2.99992V5.33325C5.83203 5.60659 5.60536 5.83325 5.33203 5.83325C5.0587 5.83325 4.83203 5.60659 4.83203 5.33325V2.99992C4.83203 1.72659 5.72536 0.833252 6.9987 0.833252H8.9987C10.272 0.833252 11.1654 1.72659 11.1654 2.99992V5.33325C11.1654 5.60659 10.9387 5.83325 10.6654 5.83325Z",
  fill: "#697B8E"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.6654 11.8466C13.6454 11.8533 13.6254 11.8533 13.6054 11.8533H5.33203C5.0587 11.8533 4.83203 11.6266 4.83203 11.3533C4.83203 11.0733 5.0587 10.8533 5.33203 10.8533H13.5454L13.6454 11.6866C13.652 11.7399 13.6587 11.7933 13.6654 11.8466Z",
  fill: "#697B8E"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ResealeIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_5))
}
}

})